import Swiper from "swiper";
import { Pagination, Navigation, Autoplay, FreeMode } from "swiper/modules";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/* MENU */
const nav = document.querySelector(".wp-block-navigation");
const burgerBtn = nav?.querySelector(
  ".wp-block-navigation__responsive-container-open",
);
const container = nav?.querySelector(
  ".wp-block-navigation__responsive-container",
);
const submenuItems = nav?.querySelectorAll("li.wp-block-navigation-submenu");
const header = document.querySelector("header");
const BREAKPOINT = 1024;
const isMobile = () => window.innerWidth < BREAKPOINT;

if (burgerBtn && container) {
  burgerBtn.addEventListener("click", () => {
    container.classList.toggle("is-menu-open");
    header.classList.toggle("is-menu-open");
  });
}

submenuItems?.forEach((item) => {
  item.addEventListener("click", (e) => {
    if (!isMobile()) return;

    const link = item.querySelector("a.wp-block-navigation-item__content");
    if (link && link.contains(e.target)) e.preventDefault();

    e.stopPropagation();

    const isOpen = item.classList.contains("is-submenu-open");
    document
      .querySelectorAll("li.wp-block-navigation-submenu.is-submenu-open")
      .forEach((el) => {
        if (el !== item) el.classList.remove("is-submenu-open");
      });

    item.classList.toggle("is-submenu-open", !isOpen);
  });
});

const relocateResponsiveContainer = () => {
  if (!container || !header) return;
  if (isMobile()) {
    if (container.parentNode !== document.body)
      document.body.appendChild(container);
  } else {
    if (container.parentNode !== nav) nav.appendChild(container);
  }
};

relocateResponsiveContainer();
window.addEventListener("resize", () => {
  relocateResponsiveContainer();
  if (!isMobile() && container?.classList.contains("is-menu-open")) {
    container.classList.remove("is-menu-open");
  }
});

/* END MENU */

/* FORMINATOR */
document.addEventListener("click", (e) => {
  const field = e.target.closest(".progetto .forminator-field");
  if (!field) return;

  let radio = e.target.closest(".forminator-radio");
  if (!radio) radio = field.querySelector(".forminator-radio");
  if (!radio) return;

  const input = radio.querySelector('input[type="radio"]');
  if (input) {
    input.checked = true;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
});
/* END FORMINATOR */

/* SOLUZIONI TABBER */
document.querySelectorAll(".soluzioni").forEach((wrapper) => {
  const tabs = Array.from(wrapper.querySelectorAll(".soluzioni__tab"));
  const panels = Array.from(wrapper.querySelectorAll(".soluzioni__panel"));
  const headers = Array.from(
    wrapper.querySelectorAll(".soluzioni__accordion-header"),
  );
  const isMobileTabber = () => window.matchMedia("(max-width: 767px)").matches;

  function activateTab(targetId) {
    tabs.forEach((tab) => {
      const active = tab.dataset.target === targetId;
      tab.classList.toggle("is-active", active);
      tab.setAttribute("aria-selected", active ? "true" : "false");
      tab.setAttribute("tabindex", active ? "0" : "-1");
    });
    panels.forEach((panel) => {
      const active = panel.id === `panel-${targetId}`;
      panel.classList.toggle("is-active", active);
      active
        ? panel.removeAttribute("hidden")
        : panel.setAttribute("hidden", "");
      const header = panel.querySelector(".soluzioni__accordion-header");
      if (header)
        header.setAttribute("aria-expanded", active ? "true" : "false");
    });
  }

  function toggleAccordion(targetId) {
    panels.forEach((panel) => {
      const isTarget = panel.id === `panel-${targetId}`;
      const wasOpen = panel.classList.contains("is-active");
      const header = panel.querySelector(".soluzioni__accordion-header");
      if (isTarget) {
        const willOpen = !wasOpen;
        panel.classList.toggle("is-active", willOpen);
        if (header)
          header.setAttribute("aria-expanded", willOpen ? "true" : "false");
      } else {
        panel.classList.remove("is-active");
        if (header) header.setAttribute("aria-expanded", "false");
      }
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      if (!isMobileTabber()) activateTab(tab.dataset.target);
    });
    tab.addEventListener("keydown", (e) => {
      if (isMobileTabber()) return;
      const index = tabs.indexOf(tab);
      if (e.key === "ArrowDown" || e.key === "ArrowRight") {
        e.preventDefault();
        const next = tabs[(index + 1) % tabs.length];
        next.focus();
        activateTab(next.dataset.target);
      }
      if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
        e.preventDefault();
        const prev = tabs[(index - 1 + tabs.length) % tabs.length];
        prev.focus();
        activateTab(prev.dataset.target);
      }
    });
  });

  headers.forEach((header) => {
    header.addEventListener("click", () => {
      if (isMobileTabber()) toggleAccordion(header.dataset.target);
    });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isMobileTabber()) {
        const active = tabs.find((t) => t.classList.contains("is-active"));
        activateTab(active ? active.dataset.target : tabs[0]?.dataset.target);
      }
    }, 150);
  });
});
/* END SOLUZIONI TABBER */

/* GSAP ANIMATIONS */
document.querySelectorAll(".freccia").forEach((el) => {
  gsap.fromTo(
    el,
    { "--line-height": "0%" },
    {
      "--line-height": "100%",
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top 80%",
        end: "bottom 20%",
        scrub: true,
      },
    },
  );
});

document.querySelectorAll(".slide-in-up, .slide-in-down").forEach((el) => {
  const direction = el.classList.contains("slide-in-down") ? "-100%" : "100%";
  gsap.from(gsap.utils.toArray(el.children), {
    y: direction,
    duration: 1.5,
    ease: "power2.out",
    scrollTrigger: {
      trigger: el,
      start: "top 85%",
      toggleActions: "play none none none",
    },
  });
});

const wideSize = parseFloat(
  getComputedStyle(document.documentElement).getPropertyValue(
    "--wp--style--global--wide-size",
  ),
);

document.querySelectorAll(".zoom-wide-to-full").forEach((el) => {
  const ratio = wideSize / window.innerWidth;
  const isAboveFold = el.getBoundingClientRect().top < window.innerHeight;

  if (isAboveFold) {
    gsap.fromTo(
      el,
      { scaleX: ratio, scaleY: ratio },
      { scaleX: 1, scaleY: 1, ease: "power2.out", duration: 1.2, delay: 0.2 },
    );
  } else {
    gsap.fromTo(
      el,
      { scaleX: ratio, scaleY: ratio },
      {
        scaleX: 1,
        scaleY: 1,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top 90%",
          end: "bottom 60%",
          scrub: 1,
        },
      },
    );
  }
});

document.querySelectorAll(".scale-image").forEach((el) => {
  gsap.fromTo(
    el,
    { scale: 0.9 },
    {
      scale: 1,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start: "top bottom",
        end: "bottom bottom",
        scrub: 1,
      },
    },
  );
});
/* END GSAP ANIMATIONS */

/*Slider*/
document.querySelectorAll(".ultimi-posts--slider-1").forEach((wrapper) => {
  const sliderEl = wrapper.querySelector(".slider1");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const pagEl = wrapper.querySelector(".swiper-pagination");

  new Swiper(sliderEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: { prevEl, nextEl },
    pagination: {
      el: pagEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<div class="' +
          currentClass +
          '"></div>' +
          '<div class="swiper-pagination-separator"></div>' +
          '<div class="' +
          totalClass +
          '"></div>'
        );
      },
    },
  });
});

document.querySelectorAll(".ultimi-posts--slider-2").forEach((wrapper) => {
  const sliderEl = wrapper.querySelector(".slider2");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const pagEl = wrapper.querySelector(".swiper-pagination");

  new Swiper(sliderEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: { prevEl, nextEl },
    pagination: {
      el: pagEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<div class="' +
          currentClass +
          '"></div>' +
          '<div class="swiper-pagination-separator"></div>' +
          '<div class="' +
          totalClass +
          '"></div>'
        );
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
    },
  });
});

document.querySelectorAll(".ultimi-posts--slider-3").forEach((wrapper) => {
  const sliderEl = wrapper.querySelector(".slider3");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const pagEl = wrapper.querySelector(".swiper-pagination");

  new Swiper(sliderEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: { prevEl, nextEl },
    pagination: {
      el: pagEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<div class="' +
          currentClass +
          '"></div>' +
          '<div class="swiper-pagination-separator"></div>' +
          '<div class="' +
          totalClass +
          '"></div>'
        );
      },
    },
  });
});

document.querySelectorAll(".ultimi-posts--slider-4").forEach((wrapper) => {
  const sliderEl = wrapper.querySelector(".slider4");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const pagEl = wrapper.querySelector(".swiper-pagination");

  new Swiper(sliderEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: { prevEl, nextEl },
    pagination: {
      el: pagEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<div class="' +
          currentClass +
          '"></div>' +
          '<div class="swiper-pagination-separator"></div>' +
          '<div class="' +
          totalClass +
          '"></div>'
        );
      },
    },
  });
});

document.querySelectorAll(".posizioni-lavorative-attive").forEach((wrapper) => {
  const sliderEl = wrapper.querySelector(".slider-posizioni");
  const prevEl = wrapper.querySelector(".swiper-button-prev");
  const nextEl = wrapper.querySelector(".swiper-button-next");
  const pagEl = wrapper.querySelector(".swiper-pagination");

  new Swiper(sliderEl, {
    modules: [Pagination, Navigation],
    slidesPerView: 2,
    spaceBetween: 0,
    navigation: { prevEl, nextEl },
    pagination: {
      el: pagEl,
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return (
          '<div class="' +
          currentClass +
          '"></div>' +
          '<div class="swiper-pagination-separator"></div>' +
          '<div class="' +
          totalClass +
          '"></div>'
        );
      },
    },
  });
});
